import axios from "axios";
import { ADMIN_TOKEN_KEY } from "./authApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function headers(extra = {}) {
  const t = localStorage.getItem(ADMIN_TOKEN_KEY);
  return { ...(t ? { Authorization: `Bearer ${t}` } : {}), ...extra };
}

export const rupees = (paise) =>
  `₹${(Number(paise || 0) / 100).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const voiceApi = {
  campaigns: (params = {}) => axios.get(`${API}/admin/voice/campaigns`, { params, headers: headers() }).then(r => r.data),
  createCampaign: (body) => axios.post(`${API}/admin/voice/campaigns`, body, { headers: headers({ "Content-Type": "application/json" }) }).then(r => r.data),
  launch: (id) => axios.post(`${API}/admin/voice/campaigns/${id}/launch`, {}, { headers: headers() }).then(r => r.data),
  pause: (id) => axios.post(`${API}/admin/voice/campaigns/${id}/pause`, {}, { headers: headers() }).then(r => r.data),
  retriggerFailed: (id) => axios.post(`${API}/admin/voice/campaigns/${id}/retrigger-failed`, {}, { headers: headers() }).then(r => r.data),
  calls: (params = {}) => axios.get(`${API}/admin/voice/calls`, { params, headers: headers() }).then(r => r.data),
  call: (id) => axios.get(`${API}/admin/voice/calls/${id}`, { headers: headers() }).then(r => r.data),
  retrigger: (id, reason) => axios.post(`${API}/admin/voice/calls/${id}/retrigger`, { reason }, { headers: headers() }).then(r => r.data),
  scripts: () => axios.get(`${API}/admin/voice/scripts`, { headers: headers() }).then(r => r.data),
};
